module.exports = __webpack_public_path__ + "img/icon-slot-black.8f6c14c3.svg";